module.exports = __webpack_public_path__ + "img/ff-insta-1b.f81fd647.jpg";